import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MyConfigOrganization } from '../../../../models/myConfig';
import { BackOffice24StatesService } from '../state/back-office24-states.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-customers',
  standalone: false,
  templateUrl: './customers.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './customers.component.css'
})
export class CustomersComponent {
  @Input() organization: MyConfigOrganization;
  private orgSubscription: Subscription = new Subscription();

  constructor(
    private backOffice24StatesService: BackOffice24StatesService
  ) { }

  ngOnInit(): void {
    this.orgSubscription = this.backOffice24StatesService.currentOrganization$.subscribe(
      org => this.organization = org
    );
  }

  ngOnDestroy(): void {
    this.orgSubscription.unsubscribe();
  }
}
